import { useState, useEffect } from 'react'
import RadioButtonGroup from '../RadioButtonGroup'
import { Spacing, Heading, LoadingSpinner, Button } from '@big-red-group/storefront-common-ui'
import SingleRangeSlider from '../SingleRangeSlider'
import { signIn } from 'next-auth/react'
import { useAuthSession } from '@/hooks/AuthSessionHook'
import { useSession } from 'next-auth/react'
import Icon from '../Icons'

import {
  VelocityEarnRedeem,
  VelocityPointsCont,
  VelocityPointsAmt,
  VelocityDescription,
  VelocityBurnCont,
  VelocityBurnTotal,
  Feedback,
} from './CheckoutForm.styles'
import { centsToDollars, useCart } from '@big-red-group/storefront-common-checkout'
import { getUrlPrefix } from '@/helpers/UrlHelper'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'

const CheckoutForm = ({ setBurnLoyaltyPoints, setLoyaltyOperationType, setAllowProceedCheckout, onBlur }: any) => {
  const { unauthenticated } = useAuthSession()
  const { data: user } = useSession()
  const [velocityPointsType, setVelocityPointsType] = useState<string>('')
  const [sliderValue, setSliderValue] = useState(2000)
  const defaultProperties = useDefaultProperties()
  const baseUrl = getUrlPrefix(defaultProperties?.agentConfiguration?.handlerKey)
  const { isLoading, data: cart } = useCart('cart', baseUrl)
  const [signInSpinning, setSignInSpinning] = useState(false)

  const handleSliderRelease = () => {
    onBlur()
  }

  useEffect(() => {
    setBurnLoyaltyPoints(2000)
  }, [])

  // Velocity button disabled logic
  useEffect(() => {
    if (velocityPointsType === 'burn' && user?.pointBalance! < 2000) {
      setAllowProceedCheckout(false)
    }
  }, [setAllowProceedCheckout, user?.pointBalance, velocityPointsType])

  const handleSliderChange = (newValue: number) => {
    setSliderValue(newValue)
    setBurnLoyaltyPoints(newValue)
  }

  const handleVelocityPointsChange = (value: string) => {
    setVelocityPointsType(value)
    setLoyaltyOperationType(value)
    sessionStorage.setItem('velocityTransactionType', value)
    user?.pointBalance! < 2000 && setSliderValue(0)
  }

  useEffect(() => {
    setLoyaltyOperationType(window.sessionStorage.getItem('velocityTransactionType') ?? 'earn')
    window.sessionStorage.getItem('velocityTransactionType') ||
      window.sessionStorage.setItem('velocityTransactionType', 'earn')

    setVelocityPointsType(window.sessionStorage.getItem('velocityTransactionType') ?? 'earn')
    window.sessionStorage.getItem('velocityTransactionType') ||
      window.sessionStorage.setItem('velocityTransactionType', 'earn')
  }, [setLoyaltyOperationType])

  if (isLoading || !cart) {
    return (
      <Feedback>
        <LoadingSpinner />
      </Feedback>
    )
  }

  const options = [
    {
      label: 'Earn Velocity Points',
      description: 'Pay cash and earn Velocity Points',
      value: 'earn',
      checked:
        sessionStorage.getItem('velocityTransactionType') === 'earn' ||
        sessionStorage.getItem('velocityTransactionType') !== 'burn',
    },
    {
      label: 'Redeem Velocity Points',
      description: 'Pay in Velocity Points',
      value: 'burn',
      checked: sessionStorage.getItem('velocityTransactionType') === 'burn',
    },
  ]

  // TODO: This should come from whitelabel stylesheet API call
  const velocityButtonStyle = {
    background: '#E10A0A',
    borderRadius: '4px',
    borderColor: '#D6083B',
    color: 'white',
    width: '200px',
  }

  const velocityButtonDisabledStyle = {
    background: 'lightgrey',
    borderRadius: '4px',
    borderColor: 'lightgrey',
    color: 'white',
    width: '200px',
  }

  return (
    <VelocityEarnRedeem>
      <Heading size="S" customMobileSize="XL">
        Earn Velocity Points
      </Heading>
      {/* <Heading size="S" customMobileSize="XL">
        Earn or redeem Velocity Points
      </Heading> */}
      <RadioButtonGroup
        options={options}
        onChange={handleVelocityPointsChange}
        name="velocity-points-type"
        isDisabled={false}
        showDescription
      />
      <Spacing size="S" />
      <>
        {unauthenticated && !user && velocityPointsType === 'burn' ? (
          <>
            <VelocityDescription>
              Please sign into your Velocity Frequent Flyer account to continue your booking, and don&apos;t worry -
              you&apos;ll be redirected right back here.
            </VelocityDescription>
            <Spacing size="L" />
            <Button
              style={signInSpinning ? velocityButtonDisabledStyle : velocityButtonStyle}
              onClick={() => {
                setSignInSpinning(true)
                signIn('virgin')
              }}
              loading={signInSpinning}
              disabled={signInSpinning}
            >
              Sign in
            </Button>
          </>
        ) : (
          <>
            {velocityPointsType === 'burn' && (
              <>
                <VelocityPointsCont>
                  You have
                  <span>
                    <Icon name="velocityPoints" height={21} width={21} />
                    <VelocityPointsAmt>{user?.pointBalance!.toLocaleString()}</VelocityPointsAmt> Velocity Points
                  </span>
                </VelocityPointsCont>
                {user?.pointBalance! < 2000 ? (
                  <p>Not enough Velocity points to redeem</p>
                ) : (
                  <VelocityBurnCont>
                    <VelocityBurnTotal>
                      <span>Total:</span> Points {sliderValue!.toLocaleString()} + $
                      {(centsToDollars(cart?.total) - sliderValue * 0.006).toFixed(2).toLocaleString()} AUD
                    </VelocityBurnTotal>
                    <SingleRangeSlider
                      min={2000}
                      max={
                        centsToDollars(cart?.total) / 0.006 - 10 > user?.pointBalance!
                          ? (user?.pointBalance as number)
                          : (((centsToDollars(cart?.total) - 10) / 0.006) as number)
                      }
                      value={sliderValue}
                      setValue={setSliderValue}
                      onChange={handleSliderChange}
                      onMouseUp={handleSliderRelease}
                      onTouchEnd={handleSliderRelease}
                    />
                  </VelocityBurnCont>
                )}
              </>
            )}
          </>
        )}
      </>
      <Spacing size="XXL" />
    </VelocityEarnRedeem>
  )
}

export default CheckoutForm
